module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"addressSearch":"Enter your address so we can match bundles available in your area","authorHeader":"{0}\u0027s articles","header":"Latest {0} articles","searchHeader":"Search results for {query}","tagHeader":"Latest articles tagged with {tag}"}}')
  delete Component.options._Ctor
}
